module.exports = __webpack_public_path__ + "assets/img/grid_blue.78bf9988.png";